let env = 'http://localhost';
let env_port = 'http://localhost:83';
let NODE_ENV = process.env.NODE_ENV;

if ( process.env.NODE_ENV === 'production' ) {
//console.log("Production Mode");
	//env = 'http://175.200.166.59';
	// 230906 도메인
	//env = 'http://43.201.84.132';
  env = '';
} else if ( process.env.NODE_ENV === 'development' ) {
//console.log("Development Mode");
	env = 'http://192.168.10.32:83';
} else if ( process.env.NODE_ENV === 'local' ) {
//console.log("Localhost Mode");
	env = 'http://localhost:83';
}

/*
const recordSFLog = async (req, res) => {
	let mm = 0;
	let mn = '';
	let mn2 = '';

	const params = new URLSearchParams();
	Object.keys(req).forEach(v => {
		if (req[v] === undefined || req[v] === null ) {
			return;
		}
		params.append(v, req[v]);
	});

	if (!!res) {
		Object.keys(res).forEach(v => {
			if (res[v] === undefined || res[v] === null ) {
				return;
			}
			params.append(v, res[v]);
		});
	}

	params.append('SFLog_URL', window.location.pathname);

	// 2023-06-26 추가
	JSON.parse(localStorage.getItem('menu')).forEach((key, value) => {
		if ( key.Menu_Sub === 0 && key.Menu_Path === window.location.pathname.split('/')[1] ) {
			mm = key.Menu_Main;
			mn = key.Menu_Name;
		}
	});

	JSON.parse(localStorage.getItem('menu')).forEach((key, value) => {
		if ( key.Menu_Main === mm && key.Menu_Sub != 0 && key.Menu_Path === window.location.pathname.split('/')[2] ) {
			mn2 = key.Menu_Name;
		}
	});

	params.append('SFLog_Menu', `${mn} / ${mn2} `);

	if ( process.env.NODE_ENV === 'production' ) {
		params.forEach((key, value) => {
	console.log(key, value);
		});
	}

	await axios.post(`${env}/api/app/common/sflog`, params )
	.then((res) => {
		if ( process.env.NODE_ENV === 'production' ) {
console.log(res.data.result);
		}
console.log('스마트팩토리 로그 기록 완료');

	})
	.catch((error) => {
		console.log(error)
	});
}

const sendSFLog = async (method='조회', rows=1) => {
	var d = new Date();
	var year = d.getFullYear();
	var month = ('0' + (d.getMonth() + 1)).slice(-2);
	var day = ('0' + d.getDate()).slice(-2);
	var hours = ('0' + d.getHours()).slice(-2);
	var minutes = ('0' + d.getMinutes()).slice(-2);
	var seconds = ('0' + d.getSeconds()).slice(-2);
	var msec = ('0' + d.getMilliseconds()).slice(-3);

	var datetime = year + '-' + month  + '-' + day + " " + hours + ":" + minutes + ":" + seconds + "." + msec;

	var param = {
		'crtfcKey' : "$5$API$fRmdTa8QL273kGAkmyHP/vD8B0fKt7x/u2ipykyyWm0",
		'logDt' : datetime,
		'useSe' : method, // 조회,등록,수정,삭제
		'sysUser' : `지구사랑 ${localStorage.getItem('mb_nick')} ${localStorage.getItem('mb_name')}`,
		'conectIp' : "175.200.166.59", //"106.244.28.69",
		'dataUsgqty' : 24000
	};

	if (method=='등록') {
		param.dataUsgqty = 36000*rows;
	} else if (method=='수정') {
		param.dataUsgqty = 24000;
	} else if (method=='삭제') {
		param.dataUsgqty = 4096;
	} else {
		param.dataUsgqty = 34000*rows;
	}

	if ( process.env.NODE_ENV === 'production' ) {
		$.ajax({
			type : "POST",
			url : "#https://log.smart-factory.kr/apisvc/sendLogData.json",
			cache : false,
			timeout : 360000,
			data : param,
			dataType : "json",
			beforeSend : function() {
			},
			success : function(data, textStatus, jqXHR) {
				var result = data.result;
	console.log('스마트팩토리 로그 전송 완료');
	recordSFLog(param, result);
			},
			error : function(jqXHR, textStatus, errorThrown) {
			},
			complete : function() {
			}
		});
	} else {
		console.log(`<<TEST>>스마트팩토리 로그 [${method} / ${rows}]<<TEST>>`);
		recordSFLog(param);
		return false;
	}
}
*/

export { env };